<template>
<div class="DistributionList">
    <div class="filters">
        <div class="add">
            <el-button type="success" @click="handleExport">导出</el-button>
        </div>
        <div class="search">
            <el-input v-model="param.customername" placeholder="请输入分销人昵称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="subject" label="分销人" min-width="250px" class-name="title">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.headimgurl" :alt="scope.row.headername"
                             preview="LeaderList">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="mobileno" label="联系电话" class-name="center" min-width="120px"></el-table-column>
            <el-table-column prop="ordercount" label="分销订单数（个）" class-name="center" min-width="150px"></el-table-column>
            <el-table-column prop="finalpaymoney" label="分销订单金额（元）" class-name="center" min-width="150px">
                <template slot-scope="scope">￥{{scope.row.finalpaymoney}}</template>
            </el-table-column>
            <el-table-column prop="brokerageraterecommend" label="分销佣金（元）" class-name="center" min-width="150px">
                <template slot-scope="scope">￥{{scope.row.parentusermoney}}</template>
            </el-table-column>
            <el-table-column label="操作" min-width="120px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn">
                            <el-button @click="handleView(scope.row)" type="text" size="small">明细</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
    <distributionViewDialog ref="distributionViewDialog"></distributionViewDialog>
</div>
</template>

<script>
import {getShareCustomerListByBrand, exportShareCustomerListByBrand} from 'api/brandBusiness'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {initPage} from 'common/js/mixin'
import {dateFormat} from 'common/js/tools'
import DistributionViewDialog from 'views/brandBusiness/distribution/components/distributionViewDialog.vue'

export default {
    name: 'DistributionList',
    mixins: [initPage],
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            param: {
                customername: ''
            },
            tableData: [],
            total: 0
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleView(obj) {
            this.$refs.distributionViewDialog.openDialog(obj)
        },
        handleQuery() {
            this.setParams(this._.cloneDeep(this.param))
            this.$refs.page.handleSizeChange(1)
        },
        handleExport() {
            this.setLoading(true)
            exportShareCustomerListByBrand({
                data: Object.assign({}, this.param),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '分销员' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            let param = this._.cloneDeep(this.param)
            this.setLoading(true)
            getShareCustomerListByBrand({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.sharelist
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Page, DistributionViewDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.DistributionList {
    .imageText {
        display: flex;
        .img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
}
</style>
